const bigscreen = {
  namespaced: true,
  state: {
    projectId: '',
    vmGroupList: [],
    moduleList: [],
    deviceCmds: [],
    makeSetCJs: [],
    makeSetCXs: [],
    makeSetSWs: [],
    isFull: false,
  },
  mutations: {
    SET_PROJECT_ID(state, id) {
      state.projectId = id
    },
    SET_MODULE_LIST(state, list) {
      state.moduleList = list
    },
    SET_VMGROUP_LIST(state, list) {
      state.vmGroupList = list
    },
    SET_DEVICE_CMDS(state, list) {
      state.deviceCmds = list
    },
    SET_MAKE_SET_CJS(state, list) {
      state.makeSetCJs = list
    },
    SET_MAKE_SET_CXS(state, list) {
      state.makeSetCXs = list
    },
    SET_MAKE_SET_SWS(state, list) {
      state.makeSetSWs = list
    },
    SET_FULL(state, flag) {
      state.isFull = flag
    },
  },
  actions: {
    setProjectId({ commit }, id) {
      commit('SET_PROJECT_ID', id)
    },
    setModuleList({ commit }, list) {
      commit('SET_MODULE_LIST', list)
    },
    setVmGroupList({ commit }, list) {
      commit('SET_VMGROUP_LIST', list)
    },
    setDeviceCmds({ commit }, list) {
      commit('SET_DEVICE_CMDS', list)
    },
    setMakeSetCJs({ commit }, list) {
      commit('SET_MAKE_SET_CJS', list)
    },
    setMakeSetCXs({ commit }, list) {
      commit('SET_MAKE_SET_CXS', list)
    },
    setMakeSetSWs({ commit }, list) {
      commit('SET_MAKE_SET_SWS', list)
    },
    setFull({ commit }, flag) {
      commit('SET_FULL', flag)
    },
  },
  getters: {
    getProjectId: (state) => state.projectId,
    getModuleList: (state) => state.moduleList,
    getVmGroupList: (state) => state.vmGroupList,
    getDeviceCmds: (state) => state.deviceCmds,
    getMakeSetCJs: (state) => state.makeSetCJs,
    getMakeSetCXs: (state) => state.makeSetCXs,
    getMakeSetSWs: (state) => state.makeSetSWs,
    getFull: (state) => state.isFull,
  },
}

export default bigscreen
